import { SvgIcon } from "@mui/material"

import { ReactComponent as SurfaceAndStructureIcon } from "./RoadSurfaceAndStructure.svg"

export const RoadSurfaceAndStructureIcon = (props) => {
    return (
        <SvgIcon component={SurfaceAndStructureIcon} {...props} inheritViewBox />
    )
}